import RouteStatus from '../../enums/RouteStatus';

export const EMPTY_DRIVER = {
  driverCode: '',
  driverName: '',
  displayName: '',
  dutyStartTime: '',
  dutyEndTime: '',
  plannedDepartTime: '',
  plannedReturnTime: '',
  deliveryStopTime: '',
  collectionStopTime: '',
  vehicleTypeDescription: '',
  vehicleTypeCode: '',
  sectionCode: '',
  sectionName: '',
  saturnLockdown: false,
  startAtSatellite: false,
  endAtSatellite: false,
};
export const EDITABLE_ROUTE_STATUSES = [
  RouteStatus.OPEN,
  RouteStatus.READY,
  RouteStatus.LOADING,
  RouteStatus.IN_BUILD,
  RouteStatus.VOID,
];

export const DRIVER_TYPES = {
  ODF: 'O',
  LINKED: 'D',
  CHOICE: 'I',
};

export const EMPTY_ODF_DRIVER = {
  driverCode: 'None',
  value: 'None',
  label: 'None',
};
